var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compliance__details"},[_c('div',{staticClass:"compliance__details__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"compliance__details__value"},[_vm._v(" "+_vm._s(_vm._f("baseDate")(_vm.compliance.documentValidFromDate))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }